import { decodeHexResponse } from '../_common/common.utils';
import SectionTypes from './section.types';

const INITIAL_STATE = {
	createSectionResponse: null,
	updateSectionResponse: null,
	getSectionResponse: null,
	getSectionsByOrganisationResponse: null,
};

const sectionReducer = (state = INITIAL_STATE, action: { type: string; payload?: any }) => {
	switch (action.type) {
		// Create Section
		case SectionTypes.CREATE_SECTION_START:
			return { ...state, createSectionResponse: null };
		case SectionTypes.CREATE_SECTION_SUCCESS:
			return {
				...state,
				createSectionResponse: decodeHexResponse(
					action.payload,
					SectionTypes.CREATE_SECTION_KEY,
				),
			};
		case SectionTypes.CREATE_SECTION_FAILURE:
			return {
				...state,
				createSectionResponse: decodeHexResponse(
					action.payload,
					SectionTypes.CREATE_SECTION_KEY,
				),
			};
		// Update Section
		case SectionTypes.UPDATE_SECTION_START:
			return { ...state, updateSectionResponse: null };
		case SectionTypes.UPDATE_SECTION_SUCCESS:
			return {
				...state,
				updateSectionResponse: decodeHexResponse(
					action.payload,
					SectionTypes.UPDATE_SECTION_KEY,
				),
			};
		case SectionTypes.UPDATE_SECTION_FAILURE:
			return {
				...state,
				updateSectionResponse: decodeHexResponse(
					action.payload,
					SectionTypes.UPDATE_SECTION_KEY,
				),
			};
		// Get Sections By Organisation
		case SectionTypes.GET_SECTIONS_BY_ORGANISATION_START:
			return { ...state };
		case SectionTypes.GET_SECTIONS_BY_ORGANISATION_SUCCESS:
			return {
				...state,
				getSectionsByOrganisationResponse: decodeHexResponse(
					action.payload,
					SectionTypes.GET_SECTIONS_BY_ORGANISATION_KEY,
				),
			};
		case SectionTypes.GET_SECTIONS_BY_ORGANISATION_FAILURE:
			return {
				...state,
				getSectionsByOrganisationResponse: decodeHexResponse(
					action.payload,
					SectionTypes.GET_SECTIONS_BY_ORGANISATION_KEY,
				),
			};

		default:
			return state;
	}
};

export default sectionReducer;
